@if (applicationResource) {
  <div class="info">
    <div class="infoItem"><b>Aplicación:</b> {{ applicationResource.id }}</div>
    @if (applicationResource.insurer) {
      <div class="infoItem"><b>Aseguradora</b>: {{
          insurers.get(applicationResource.insurer.id)?.description
        }}
      </div>
    }
    <div class="infoItem"><b>Cotización</b>: {{ applicationResource.quotationIdentifier }}</div>
    <div class="infoItem"><b>Riesgo</b>: {{ applicationResource.insurableInterestIdentifier }}</div>
    <div class="infoItem"><b>Tomador</b>: {{ applicationResource.applicant?.identification }}
      - {{ applicationResource.applicant?.name }}
    </div>
    <div class="infoItem">
      <b>Asegurado</b>: {{ applicationResource.insured?.identificationNumber }}
      - {{ applicationResource.insured?.fullName }}
    </div>
  </div>
}
